import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import headerApp from "../../assets/jss-component/HeaderApp";
import Grid from "@material-ui/core/Grid";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { withRouter } from "react-router";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Typography from "@material-ui/core/Typography";
import UserService from "../../user/UserService";
import { showMessage } from "../../common/NotificationService";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Icon } from "@material-ui/core";

class DrawerLeft extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      right: false,
      loading: false,
      favorites: []
    };
  }

  componentDidMount = () => {
    this.setState({ loading: true }, () => this.getFavorites());
  };

  toggleDrawer = (side, openDrawer) => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    this.setState({ [side]: openDrawer });
  };

  favoriteClick = favoriteRoute => () => {
    this.props.history.push(favoriteRoute);
    //this.setState({ right: false });
  };

  getFavorites = () => {
    UserService.getFavorites().then(favorites =>
      this.setState({ favorites: favorites, loading: false })
    );
  };

  addFavorite = () => () => {
    this.setState({ loading: true });
    UserService.addFavorite(this.props.location.pathname)
      .then(() => this.getFavorites())
      .catch(error => {
        this.setState({ loading: false });
        showMessage("error-resp", error.data.message);
      });
  };

  removeFavorite = favoriteId => () => {
    this.setState({ loading: true });
    UserService.removeFavorite(favoriteId)
      .then(() => this.getFavorites())
      .catch(error => {
        this.setState({ loading: false });
        showMessage("error-resp", error.data.message);
      });
  };

  render() {
    const { right, classes, toggleDrawer } = this.props;

    const favoriteList = (
      <List dense>
        {this.state.favorites.map(favorite => (
          <ListItem
            button
            onClick={toggleDrawer("right", false)}
            onBlur={this.favoriteClick(favorite.route)}
          >
            <ListItemText
              primary={
                <Typography style={{ color: favorite.color, fontWeight: 900 }}>
                  {favorite.application}
                </Typography>
              }
              secondary={favorite.label}
            />
            <ListItemSecondaryAction onClick={this.removeFavorite(favorite.id)}>
              <IconButton edge="end" aria-label="delete">
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    );

    const emptyFavorites = (
      <List>
        <ListItem>
          <ListItemText secondary="No contiene favoritos guardados previamente." />
        </ListItem>
      </List>
    );

    const showProgress = <LinearProgress className="FavoritesProgress" />;

    const sideList = (
      <div className="DrawerFavorites">
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid
            container
            item
            xs={12}
            sm={12}
            direction="row"
            justify="center"
            alignItems="center"
            className="FavoritesButtonSection"
          >
            <Grid item xs={6} sm={6}>
              <h2>Favoritos</h2>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Fab
                onClick={this.addFavorite()}
                color="primary"
                aria-label="Add"
                className={classes.button}
              >
                <AddIcon />
              </Fab>
            </Grid>
          </Grid>
        </Grid>
        {this.state.loading ? (
          showProgress
        ) : (
          <div className="FavoritesProgress"></div>
        )}
        {this.state.favorites.length ? favoriteList : emptyFavorites}
      </div>
    );

    return (
      <Drawer
        anchor="right"
        open={right}
        variant="temporary"
        onClose={toggleDrawer("right", false)}
      >
        <div>{sideList}</div>
      </Drawer>
    );
  }
}

export default withRouter(withStyles(headerApp)(DrawerLeft));
